package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.LinkW500Rounded: ImageVector
    get() {
        if (_linkW500Rounded != null) {
            return _linkW500Rounded!!
        }
        _linkW500Rounded = Builder(name = "LinkW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(280.0f, 688.13f)
                quadToRelative(-86.35f, 0.0f, -147.24f, -60.89f)
                quadTo(71.87f, 566.35f, 71.87f, 480.0f)
                quadToRelative(0.0f, -86.35f, 60.89f, -147.24f)
                quadToRelative(60.89f, -60.89f, 147.24f, -60.89f)
                horizontalLineToRelative(110.91f)
                quadToRelative(19.16f, 0.0f, 32.33f, 13.17f)
                quadToRelative(13.17f, 13.18f, 13.17f, 32.33f)
                reflectiveQuadToRelative(-13.17f, 32.33f)
                quadToRelative(-13.17f, 13.17f, -32.33f, 13.17f)
                lineTo(280.0f, 362.87f)
                quadToRelative(-48.8f, 0.0f, -82.97f, 34.16f)
                quadToRelative(-34.16f, 34.17f, -34.16f, 82.97f)
                reflectiveQuadToRelative(34.16f, 82.97f)
                quadToRelative(34.17f, 34.16f, 82.97f, 34.16f)
                horizontalLineToRelative(110.91f)
                quadToRelative(19.16f, 0.0f, 32.33f, 13.17f)
                quadToRelative(13.17f, 13.18f, 13.17f, 32.33f)
                reflectiveQuadToRelative(-13.17f, 32.33f)
                quadToRelative(-13.17f, 13.17f, -32.33f, 13.17f)
                lineTo(280.0f, 688.13f)
                close()
                moveTo(356.41f, 521.91f)
                quadToRelative(-17.71f, 0.0f, -29.81f, -12.09f)
                quadToRelative(-12.1f, -12.1f, -12.1f, -29.82f)
                reflectiveQuadToRelative(12.1f, -29.82f)
                quadToRelative(12.1f, -12.09f, 29.81f, -12.09f)
                horizontalLineToRelative(247.18f)
                quadToRelative(17.71f, 0.0f, 29.81f, 12.09f)
                quadToRelative(12.1f, 12.1f, 12.1f, 29.82f)
                reflectiveQuadToRelative(-12.1f, 29.82f)
                quadToRelative(-12.1f, 12.09f, -29.81f, 12.09f)
                lineTo(356.41f, 521.91f)
                close()
                moveTo(569.09f, 688.13f)
                quadToRelative(-19.16f, 0.0f, -32.33f, -13.17f)
                quadToRelative(-13.17f, -13.18f, -13.17f, -32.33f)
                reflectiveQuadToRelative(13.17f, -32.33f)
                quadToRelative(13.17f, -13.17f, 32.33f, -13.17f)
                lineTo(680.0f, 597.13f)
                quadToRelative(48.8f, 0.0f, 82.97f, -34.16f)
                quadToRelative(34.16f, -34.17f, 34.16f, -82.97f)
                reflectiveQuadToRelative(-34.16f, -82.97f)
                quadTo(728.8f, 362.87f, 680.0f, 362.87f)
                lineTo(569.09f, 362.87f)
                quadToRelative(-19.16f, 0.0f, -32.33f, -13.17f)
                quadToRelative(-13.17f, -13.18f, -13.17f, -32.33f)
                reflectiveQuadToRelative(13.17f, -32.33f)
                quadToRelative(13.17f, -13.17f, 32.33f, -13.17f)
                lineTo(680.0f, 271.87f)
                quadToRelative(86.35f, 0.0f, 147.24f, 60.89f)
                quadToRelative(60.89f, 60.89f, 60.89f, 147.24f)
                quadToRelative(0.0f, 86.35f, -60.89f, 147.24f)
                quadToRelative(-60.89f, 60.89f, -147.24f, 60.89f)
                lineTo(569.09f, 688.13f)
                close()
            }
        }
        .build()
        return _linkW500Rounded!!
    }

private var _linkW500Rounded: ImageVector? = null
